module.exports = __webpack_public_path__ + "gt.9f2b2dfd47f0e4201f66.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gt.svg
// module chunks = styles